<!--Top Nav Header Container div-->
<div class="top-nav-header-container">
  <!--Left side container div-->
  <div class="left-side-block">
    <img src="../../../assets/img/new_dasboard_imges/BluVBay.png" height="50" width="150"/>
    <img src="../../../assets/images/New_Icons/navigation-icon-left.svg" height="60" width="150" class="web-toogle-icon" (click)="navigationToggleMenu()"/>
  </div>
  <!--Right side container div-->
  <div class="right-side-block">
   <li class="xn-icon-button pull-right account-status" *ngIf="['Business Admin', 'Provider Manager'].includes(loginPersonType) && businessEntity && businessEntity.accountStatus == 'markedForInactivation'">
    <span>
      <img src="../../assets/images/New_Icons/alert-danger-without-fill.svg" width="40px" height="40px">
    </span>
    <div>
      <span class="status-message">This account is marked for closure.</span><br>
      <span><a routerLink="/home/account-closure" class="cancel-link-message"
        *ngIf="['Business Admin'].includes(loginPersonType)">Click here to cancel</a></span>
    </div>
  </li> 
    <!--Notifications Block-->
    <div (mouseenter)="showNotifications()" (mouseleave)="hideNotifications()" style="cursor: pointer;">
      <img src="../../assets/images/New_Icons/alert-top-messages-icon.svg" class="notification-icon" *ngIf="hasAccess()">
      <div class="notfication_mssgs_count" *ngIf="pushNotficationUnReadObjects.length > 0">
        <span>{{pushNotficationUnReadObjects.length}}</span>
      </div>
      <div class="notifications-div" [ngClass]="{ 'visible': isNotificationsOpen }">
        <div class="content">
          <div class="alert-text">Alerts</div>
        </div>
        <div class="notifications-container" *ngIf="notifications && notifications.length > 0">
          <div>
            <span>Un Read Messages ({{pushNotficationUnReadObjects.length}})</span>
            <div *ngIf="pushNotficationUnReadObjects && pushNotficationUnReadObjects.length > 0">
              <div class="alert-danger-notification" *ngFor="let notification of pushNotficationUnReadObjects">
                <div class="notification-user-details" (click)="navigateToAccountClosureScreen(notification)">
                  <div>
                    <img src="../../assets/images/New_Icons/alert-danger-without-fill.svg" height="40" width="40">
                  </div>
                  <div class="user-name">
                    <span class="person-name">{{notification.message}}</span><br>
                    <span class="notification-alert-decription">{{notification.activityName}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <span>Read Messages ({{pushNotficationReadObjects.length}})</span>
            <div class="alert-danger-notification" *ngFor="let notification of pushNotficationReadObjects">
              <div class="notification-user-details" (click)="navigateToAccountClosureScreen(notification)">
                <div>
                  <img src="../../assets/images/New_Icons/alert-danger-without-fill.svg" height="40" width="40">
                </div>
                <div class="user-name">
                  <span class="person-name">{{notification.message}}</span><br>
                  <span class="notification-alert-decription">{{notification.activityName}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf=" notifications && notifications.length <= 0">
          <span class="noDataFoundMessage notifications-text">Notifications are not available</span>
        </div>
      </div>
    </div>
    <!--Profile Block-->
    <div (mouseenter)="showProfile()" (mouseleave)="hideProfile()" class="user_profile_content-web">
      <div class="user_info">
        <div class="user-details profile-web-view">
          <img src="../../../assets/images/New_Icons/login-user-icon.svg" height="35" width="35" class="profile-image" *ngIf="!loginUserBusinessIcon">
          <img src="{{loginUserBusinessIcon}}" height="35" width="35" class="profile-image" *ngIf="loginUserBusinessIcon">
          <div class="user-name">
            <span class="userName" [title]="LoginUserName">{{LoginUserName}}</span><span class="personRole">{{loginPersonType}}</span>
          </div>
        </div>
        <div class="profile-mobile-view">
          <img src="{{loginUserBusinessIcon}}" class="mobile-profile-image" *ngIf="loginUserBusinessIcon">
          <span class="mobile-no-profile-image" *ngIf="!loginUserBusinessIcon"></span>
        </div>
      </div>
      <div class="userProfile" [class.visible]="isNotificationsOpen">
        <div class="profile-info-div">
          <span class="welcome-text">Welcome</span>
          <div class="sub-user-details">
            <img src="../../../assets/img/users/no-logo.svg" height="35" width="35" class="profile-image" *ngIf="!loginUserBusinessIcon">
            <img src="{{loginUserBusinessIcon}}" height="35" width="35" class="profile-image" *ngIf="loginUserBusinessIcon">
            <div class="user-name">
              <span class="user-name-text">{{LoginUserName}}</span>
              <span class="person-role-text">{{loginPersonType}}</span>
            </div>
          </div>
        </div>
        <div>
          <div class="buttons-div">
            <div class="button-container">
              <button>
                <span class="icon"><img src="../../../assets/images/New_Icons/view-profile-icon.svg"></span>
                <span class="text">View Profile</span>
              </button>
            </div>
            <div class="button-container" (click)="logout()">
              <button>
                <span class="icon"><img src="../../../assets/images/New_Icons/signout-icon.svg"></span>
                <span class="text">Log Out</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Toogle Icon for drawer based menu-->
    <img src="../../../assets/images/navigation_menu.svg" alt="" height="50" class="mobile-toogle-icon" *ngIf="redirectTo == ''" (click)="onToggleMenu()">
  </div>
</div>
